<app-loader [loading]="loading">
    <div class="flex flex-col w-full gap-4">
        <form>
            <p-select
                inputId="timezone"
                [(ngModel)]="selectedTimezone"
                [class]="'w-full'"
                [options]="timezoneList"
                [appendTo]="'body'"
                [name]="'timezone'"
                [optionLabel]="'displayName'"
                [virtualScroll]="true"
                virtualScrollItemSize="34"
                [filter]="true"
                [attr.data-test-id]="'core-layout-navbar-timezone-select' | dataTestId">
            </p-select>
        </form>

        <div class="flex justify-end">
            <p-button
                i18n-label
                label="Save"
                [disabled]="!selectedTimezone"
                (onClick)="save()"
                [attr.data-test-id]="'core-layout-navbar-timezone-saveButton' | dataTestId">
            </p-button>
        </div>
    </div>
</app-loader>
